export const BUTTON_TYPES = {
  blue: { className: "ct-button-blue" },
  gray: { className: "ct-button-gray" },
};

export const DEFAULT_ITEM_PER_PAGE = 20;

function generateYear({ fromYear, toYear, labelSuffix = "" }) {
  let result = [];
  for (let i = fromYear; i <= toYear; i++) {
    result.push({
      key: i,
      label: `${i}${labelSuffix}`,
    });
  }
  return result;
}

export const BIRTHYEAR_OPTIONS = generateYear({
  fromYear: 1900,
  toYear: 2010,
  labelSuffix: "年",
});

export const BIRTHYEAR_OPTIONS_WITHOUT_TEXT = generateYear({
  fromYear: 1900,
  toYear: 2010,
});

export const HEIGHT_OPTIONS = (function () {
  let from = 100;
  let to = 250;
  let result = [];
  for (let i = from; i <= to; i++) {
    result.push({
      key: i,
      label: `${i}`,
    });
  }
  return result;
})();

export const WEIGHT_OPTIONS = (function () {
  let from = 10;
  let to = 200;
  let result = [];
  for (let i = from; i <= to; i++) {
    result.push({
      key: i,
      label: `${i}`,
    });
  }
  return result;
})();

export const SEXS = [
  {
    key: 1,
    label: "男性",
  },
  {
    key: 2,
    label: "女性",
  },
];

export const TODAY_INFO = {
  key: 1,
  label: "1日",
};
export const WEEK_INFO = {
  key: 2,
  label: "7日間",
};
export const MONTH_INFO = {
  key: 3,
  label: "30日間",
};
export const SEMIANUAL_INFO = {
  key: 4,
  label: "半年間",
};
export const LAST_MONTH_LIFE_PATTERN_INFO = {
  key: 5,
  label: "31日間",
};
export const MONTH_DISTANCE_INFO = {
  key: 6,
  label: "1",
};
export const LAST_DATE_INFO = {
  key: 7,
  label: "",
};

export const CALENDARS = [TODAY_INFO, WEEK_INFO, MONTH_INFO];

export const CALENDARS_WITHOUT_WEEK = [TODAY_INFO, MONTH_INFO, SEMIANUAL_INFO];

export const CALENDARS_WITHOUT_TODAY = [WEEK_INFO, MONTH_INFO, SEMIANUAL_INFO];

export const TODAY = TODAY_INFO.key;
export const WEEK = WEEK_INFO.key;
export const MONTH = MONTH_INFO.key;
export const SEMIANUAL = SEMIANUAL_INFO.key;
export const LAST_MONTH_LIFE_PATTERN = LAST_MONTH_LIFE_PATTERN_INFO.key;
export const MONTH_DISTANCE = MONTH_DISTANCE_INFO.key;
export const LAST_DATE = LAST_DATE_INFO.key;

export const UP = 1;
export const DOWN = 2;

export const STATUS_UNAUTHORIZED = 401;

export const EDIT = "EDIT";
export const PREVIEW = "PREVIEW";

export const UNDEFINED_LABEL = "UNDEFINED_";
export const ONE_DAY = 1;
export const ONE_MONTH = 1;
export const TOTAL_DAYS_OF_A_WEEK = 7;
export const TOTAL_DAYS_OF_A_MONTH = 30;
export const TOTAL_MAX_DAYS_OF_A_MONTH = 31;
export const TOTAL_DAYS_OF_SEMIANUAL = 180;

export const WALKX_NONE = "none";
export const WALKX_ONLY = "WALKX_ONLY";
export const WALKX_0 = 0;
export const WALKX_1 = 1;
export const WALKX_2 = 2;
export const WALKX_3 = 3;
export const WALKX_4 = 4;
export const HIGH_BATTERY = 100;
export const MEDIUM_BATTERY = 50;
export const LOW_BATTERY = 0;
export const BATTERY_ICON_NAMES = {
  [WALKX_NONE]: {
    [HIGH_BATTERY]: "batterySilmee100.svg",
    [MEDIUM_BATTERY]: "batterySilmee3090.svg",
    [LOW_BATTERY]: "batterySilmee20.svg",
  },
  [WALKX_0]: {
    [HIGH_BATTERY]: "batteryS100xW0.svg",
    [MEDIUM_BATTERY]: "batteryS3090xW0.svg",
    [LOW_BATTERY]: "batteryS20xW0.svg",
  },
  [WALKX_1]: {
    [HIGH_BATTERY]: "batteryS100xW1.svg",
    [MEDIUM_BATTERY]: "batteryS3090xW1.svg",
    [LOW_BATTERY]: "batteryS20xW1.svg",
  },
  [WALKX_2]: {
    [HIGH_BATTERY]: "batteryS100xW2.svg",
    [MEDIUM_BATTERY]: "batteryS3090xW2.svg",
    [LOW_BATTERY]: "batteryS20xW2.svg",
  },
  [WALKX_3]: {
    [HIGH_BATTERY]: "batteryS100xW3.svg",
    [MEDIUM_BATTERY]: "batteryS3090xW3.svg",
    [LOW_BATTERY]: "batteryS20xW3.svg",
  },
  [WALKX_4]: {
    [HIGH_BATTERY]: "batteryS100xW0.svg",
    [MEDIUM_BATTERY]: "batteryS3090xW0.svg",
    [LOW_BATTERY]: "batteryS20xW0.svg",
  },
  [WALKX_ONLY]: {
    [WALKX_0]: "batteryWalkX100.svg",
    [WALKX_1]: "batteryWalkX3090.svg",
    [WALKX_2]: "batteryWalkX20.svg",
    [WALKX_3]: "batteryWalkX0.svg",
    [WALKX_4]: "batteryWalkX100.svg",
    [WALKX_NONE]: "batteryWalkX100.svg",
  },
};

export const FOOD_RESULT_KEYS = {
  kujira: "kujira",
  ari: "ari",
  lion: "lion",
  maguro: "maguro",
  midorimush: "midorimush",
  gold: "gold",
  silver: "silver",
  bronze: "bronze",
  noMedal: "noMedal",
};

export const DEFAULT_AUTH = {
  userID: "",
  sessionKey: "",
  lat: "39.36600180628301",
  long: "126.62369318446645",
};

export const YES_NO_OPTIONS = [
  {
    key: 1,
    label: "1. はい",
  },
  {
    key: 2,
    label: "0. いいえ",
  },
];

export const HEALTH_STATUSES = [
  { label: "非常に健康だと思う", key: "1" },
  { label: "まあ健康な方だと思う", key: "2" },
  { label: "あまり健康ではない", key: "3" },
  { label: "健康ではない", key: "4" },
];
